import { render } from "./InstagramIcon.vue?vue&type=template&id=5310ef97&scoped=true"
import script from "./InstagramIcon.vue?vue&type=script&lang=js"
export * from "./InstagramIcon.vue?vue&type=script&lang=js"

import "./InstagramIcon.vue?vue&type=style&index=0&id=5310ef97&scoped=true&lang=css"

import exportComponent from "/Users/muftaua/Documents/dev/CCD-Stuff/web-ccd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5310ef97"]])

export default __exports__